import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function AddEmployee({ className }: IconProps) {
  return (
    <svg
      width="83"
      height="70"
      viewBox="0 0 83 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3848)">
        <path
          d="M49.842 54.4937H23.2598V65.1266H49.842V54.4937Z"
          fill="#EAEEF9"
        />
        <path
          d="M69.3354 56.4873H3.98734C1.77215 56.4873 0 54.7152 0 52.5V3.98734C0 1.77215 1.77215 0 3.98734 0H69.3354C71.5506 0 73.3228 1.77215 73.3228 3.98734V52.5C73.3228 54.7152 71.3291 56.4873 69.3354 56.4873Z"
          fill="#EAEEF9"
        />
        <path
          d="M60.9181 70H12.4055C11.0763 70 9.96875 68.8924 9.96875 67.5633C9.96875 66.2342 11.0763 65.1266 12.4055 65.1266H60.9181C62.2472 65.1266 63.3548 66.2342 63.3548 67.5633C63.1333 68.8924 62.2472 70 60.9181 70Z"
          fill="#EAEEF9"
        />
        <path
          d="M66.234 51.6139H7.0884C5.9808 51.6139 5.09473 50.7279 5.09473 49.6203V7.08861C5.09473 5.98102 5.9808 5.09494 7.0884 5.09494H66.234C67.3416 5.09494 68.2276 5.98102 68.2276 7.08861V49.6203C68.2276 50.7279 67.3416 51.6139 66.234 51.6139Z"
          fill="white"
        />
        <path
          d="M65.5699 29.019H7.75342C7.31039 29.019 7.08887 28.7975 7.08887 28.3544C7.08887 27.9114 7.31039 27.6899 7.75342 27.6899H65.5699C66.0129 27.6899 66.2344 27.9114 66.2344 28.3544C66.2344 28.576 66.0129 29.019 65.5699 29.019Z"
          fill="#00C4B3"
        />
        <path
          d="M36.5503 49.8418C36.1073 49.8418 35.8857 49.6203 35.8857 49.1772V7.31013C35.8857 6.86709 36.1073 6.64557 36.5503 6.64557C36.9933 6.64557 37.2149 6.86709 37.2149 7.31013V49.1772C37.2149 49.6203 36.9933 49.8418 36.5503 49.8418Z"
          fill="#00C4B3"
        />
        <path
          d="M20.6012 16.6139C16.1708 16.6139 12.6265 19.9367 11.9619 24.1456C11.9619 24.8101 12.405 25.2532 12.848 25.2532H28.1328C28.7974 25.2532 29.2404 24.8101 29.0189 24.1456C28.5758 19.9367 25.0315 16.6139 20.6012 16.6139Z"
          fill="#00C4B3"
        />
        <path
          d="M27.2472 11.962C27.2472 15.7278 24.3674 18.6076 20.6016 18.6076C16.8358 18.6076 13.9561 15.7278 13.9561 11.962C13.9561 8.1962 16.8358 5.31645 20.6016 5.31645C24.3674 5.31645 27.2472 8.41772 27.2472 11.962Z"
          fill="white"
        />
        <path
          d="M25.253 11.962C25.253 14.6202 23.2593 16.6139 20.6011 16.6139C17.9429 16.6139 15.9492 14.6202 15.9492 11.962C15.9492 9.30379 17.9429 7.31012 20.6011 7.31012C23.2593 7.31012 25.253 9.30379 25.253 11.962Z"
          fill="#00C4B3"
        />
        <path
          d="M52.4996 16.6139C48.0692 16.6139 44.5249 19.9367 43.8604 24.1456C43.8604 24.8101 44.3034 25.2532 44.7464 25.2532H60.0312C60.6958 25.2532 61.1388 24.8101 60.9173 24.1456C60.6958 19.9367 56.93 16.6139 52.4996 16.6139Z"
          fill="#00416B"
        />
        <path
          d="M59.1456 11.962C59.1456 15.7278 56.2659 18.6076 52.5001 18.6076C48.7342 18.6076 45.8545 15.7278 45.8545 11.962C45.8545 8.1962 48.7342 5.31645 52.5001 5.31645C56.2659 5.31645 59.1456 8.41772 59.1456 11.962Z"
          fill="white"
        />
        <path
          d="M57.1515 11.962C57.1515 14.6202 55.1578 16.6139 52.4996 16.6139C49.8413 16.6139 47.8477 14.6202 47.8477 11.962C47.8477 9.30379 49.8413 7.31012 52.4996 7.31012C55.1578 7.31012 57.1515 9.30379 57.1515 11.962Z"
          fill="#00416B"
        />
        <path
          d="M20.6012 40.3165C16.1708 40.3165 12.6265 43.6392 11.9619 47.8481C11.9619 48.5127 12.405 48.9557 12.848 48.9557H28.1328C28.7974 48.9557 29.2404 48.5127 29.0189 47.8481C28.5758 43.6392 25.0315 40.3165 20.6012 40.3165Z"
          fill="#00416B"
        />
        <path
          d="M27.2472 35.6646C27.2472 39.4304 24.3674 42.3101 20.6016 42.3101C16.8358 42.3101 13.9561 39.4304 13.9561 35.6646C13.9561 31.8987 16.8358 29.019 20.6016 29.019C24.3674 29.019 27.2472 31.8987 27.2472 35.6646Z"
          fill="white"
        />
        <path
          d="M25.253 35.6646C25.253 38.3228 23.2593 40.3165 20.6011 40.3165C17.9429 40.3165 15.9492 38.3228 15.9492 35.6646C15.9492 33.0063 17.9429 31.0127 20.6011 31.0127C23.2593 31.0127 25.253 33.0063 25.253 35.6646Z"
          fill="#00416B"
        />
        <path
          d="M79.9683 9.52531H48.291C46.9619 9.52531 45.6328 10.6329 45.6328 12.1835V46.519C45.6328 47.4051 46.7404 47.8481 47.405 47.4051L54.4936 41.6456H79.9683C81.2974 41.6456 82.6265 40.538 82.6265 38.9873V12.1835C82.6265 10.6329 81.2974 9.52531 79.9683 9.52531Z"
          fill="#00416B"
        />
        <path
          d="M67.1198 16.6139H62.6895V34.7785H67.1198V16.6139Z"
          fill="white"
        />
        <path
          d="M73.9878 23.481H55.8232V27.9114H73.9878V23.481Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3848">
          <rect width="82.6266" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
